import { Tab, Tabs } from "@mui/material";
import type { FC, SyntheticEvent } from "react";

interface NotificationCenterTabsProps {
	value: number;
	onChange: (event: SyntheticEvent, newValue: number) => void;
	tabs: { id: string; label: string }[];
}

export const NotificationCenterTabs: FC<NotificationCenterTabsProps> = ({
	value,
	onChange,
	tabs,
}) => {
	return (
		<Tabs
			value={value}
			onChange={onChange}
			variant="fullWidth"
			indicatorColor="secondary"
			deprecatedUnderline
		>
			{tabs.map((tab, index) => (
				<Tab
					key={tab.id}
					label={tab.label}
					id={`nc-tab-${index}`}
					aria-controls={`nc-tabpanel-${index}`}
				/>
			))}
		</Tabs>
	);
};
